// Original source: https://github.com/ZijingPeng/leaflet-tooltip-layout

(function (factory, window) {
  if (typeof define === 'function' && define.amd) {
    define(['leaflet'], factory)
  } else if (typeof exports === 'object') {
    module.exports = factory(require('leaflet'))
  }
  if (typeof window !== 'undefined' && window.L) {
    window.L.tooltipLayout = factory(L)
  }
})(function (L) {
  const TooltipLayout = {}

  // global variables
  let eventsAdded = false
  let map
  let markerList = [] // all markers here
  let polylineList = [] // all polylines here

  // events
  let _onPolylineCreated = null // will be called after polyline has been created

  function initialize (leafletMap, onPolylineCreated) {
    map = leafletMap
    polylineList = []

    // default style
    if (onPolylineCreated) {
      _onPolylineCreated = onPolylineCreated
    } else {
      _onPolylineCreated = function (ply) {
        ply.setStyle({
          color: '#90A4AE'
        })
      }
    }

    setRandomPos(map)
    layoutByForce()
    setEdgePosition()
    drawLine(map)

    // event registrations
    if (!eventsAdded) {
      map.on('zoomstart', function () {
        removeAllPolyline(map)
      })

      map.on('zoomend', function () {
        redraw(map)
      })

      map.on('dragend', function () {
        redraw(map)
      })

      map.on('resize', function () {
        redraw(map)
      })

      eventsAdded = true
    }
  }

  function redraw (map) {
    removeAllPolyline(map)
    setRandomPos(map)
    layoutByForce()
    setEdgePosition()
    drawLine(map)
  }

  function resetMarker (marker) {
    if (marker.getTooltip()) {
      const name = marker.getTooltip().getContent()
      const options = marker.getTooltip().options
      marker.unbindTooltip()

      marker.bindTooltip(name, {
        pane: options.pane,
        offset: options.offset,
        className: 'heading ' + options.className,
        permanent: true,
        interactive: true,
        direction: 'left',
        sticky: 'none',
        opacity: options.opacity
      })
    }
    markerList.push(marker)
  }

  function getMarkers () {
    return markerList
  }

  function removeMarkers () {
    markerList = []
    removeAllPolyline(map)
  }

  function getLine (marker) {
    return marker.__ply
  }

  function removeAllPolyline (map) {
    let i
    for (i = 0; i < polylineList.length; i++) {
      map.removeLayer(polylineList[i])
    }
    polylineList = []
  }

  /**
   * Draw lines between markers and tooltips
   * @param map leaflet map
   */
  function drawLine (map) {
    removeAllPolyline(map)
    for (let i = 0; i < markerList.length; i++) {
      const marker = markerList[i]
      const markerDom = marker._icon
      if (marker.getTooltip()) {
        const label = marker.getTooltip()
        const labelDom = label._container

        if (markerDom != null && labelDom != null) {
          const markerPosition = getPosition(markerDom)
          const labelPosition = getPosition(labelDom)

          let x1 = labelPosition.x
          let y1 = labelPosition.y

          const x = markerPosition.x
          const y = markerPosition.y

          x1 -= 5
          y1 += 2
          if (x1 - x !== 0 || y1 - y !== 0) {
            if (x1 + labelDom.offsetWidth < markerPosition.x) {
              x1 += labelDom.offsetWidth
            }
            if (y1 + labelDom.offsetHeight < markerPosition.y) {
              y1 += labelDom.offsetHeight
            }
            const lineDest = L.point(x1, y1)
            const destLatLng = map.layerPointToLatLng(lineDest)

            setTimeout(
              (function (marker, destLatLng) {
                return function () {
                  const ply = L.polyline([marker.getLatLng(), destLatLng])
                  _onPolylineCreated && _onPolylineCreated(ply)
                  marker.__ply = ply
                  polylineList.push(ply)
                  ply.addTo(map)
                }
              })(marker, destLatLng),
              0
            )
          }
        }
      }
    }
  }

  function setRandomPos () {
    for (let i = 0; i < markerList.length; i++) {
      const marker = markerList[i]
      if (marker.getTooltip()) {
        const label = marker.getTooltip()
        const labelDom = label._container
        const markerDom = marker._icon
        if (markerDom != null) {
          const markerPosition = getPosition(markerDom)
          // var angle = Math.floor(Math.random() * 19 + 1) * 2 * Math.PI / 20;
          const angle = ((2 * Math.PI) / 6) * i
          const x = markerPosition.x
          const y = markerPosition.y
          const dest = L.point(
            Math.ceil(x + 50 * Math.sin(angle)),
            Math.ceil(y + 50 * Math.cos(angle))
          )
          L.DomUtil.setPosition(labelDom, dest)
        }
      }
    }
  }

  function scaleTo (a, b) {
    return L.point(a.x * b.x, a.y * b.y)
  }

  function normalize (a) {
    const l = a.distanceTo(L.point(0, 0))
    if (l === 0) {
      return a
    }
    return L.point(a.x / l, a.y / l)
  }

  function fa (x, k) {
    return (x * x) / k
  }

  function fr (x, k) {
    return (k * k) / x
  }

  /**
   * get position form el.style.transform
   */
  function getPosition (el) {
    const translateString = el.style.transform
      .split('(')[1]
      .split(')')[0]
      .split(',')
    return L.point(parseInt(translateString[0]), parseInt(translateString[1]))
  }

  /**
   * t is the temperature in the system
   */
  function computePositionStep (t, k) {
    let dpos = L.point(0, 0)
    let v_pos
    let v
    let i

    for (i = 0; i < markerList.length; i++) {
      v = markerList[i]
      // get position of label v
      v.disp = L.point(0, 0)
      if (v.getTooltip()) {
        var container_v = v.getTooltip()._container
        if (container_v != null) {
          v_pos = getPosition(container_v)

          // compute gravitational force
          for (let j = 0; j < markerList.length; j++) {
            const u = markerList[j]
            if (i !== j && u.getTooltip()) {
              const container_u = u.getTooltip()._container
              if (container_u != null) {
                const u_pos = getPosition(container_u)
                dpos = v_pos.subtract(u_pos)
                if (dpos !== 0) {
                  v.disp = v.disp.add(
                    normalize(dpos).multiplyBy(fr(dpos.distanceTo(L.point(0, 0)), k))
                  )
                }
              }
            }
          }
        }
      }
    }

    // compute force between marker and tooltip
    for (i = 0; i < markerList.length; i++) {
      v = markerList[i]
      if (v.getTooltip()) {
        var container_v = v.getTooltip()._container
        const icon_v = v._icon
        if (container_v != null && icon_v != null) {
          v_pos = getPosition(container_v)
          dpos = v_pos.subtract(getPosition(icon_v))
          v.disp = v.disp.subtract(
            normalize(dpos).multiplyBy(fa(dpos.distanceTo(L.point(0, 0)), k))
          )
        }
      }
    }

    // calculate layout
    for (i = 0; i < markerList.length; i++) {
      const disp = markerList[i].disp
      if (markerList[i].getTooltip()) {
        const tooltip_container = markerList[i].getTooltip()._container
        if (tooltip_container != null) {
          let p = getPosition(tooltip_container)
          const d = scaleTo(
            normalize(disp),
            L.point(Math.min(Math.abs(disp.x), t), Math.min(Math.abs(disp.y), t))
          )
          p = p.add(d)
          p = L.point(Math.ceil(p.x), Math.ceil(p.y))
          L.DomUtil.setTransform(markerList[i].getTooltip()._container, p)
        }
      }
    }
  }

  function layoutByForce () {
    const area = (window.innerWidth * window.innerHeight) / 10
    const k = Math.sqrt(area / markerList.length)
    const start = Math.ceil(window.innerWidth / 10)
    const times = 50
    let t
    for (var i = 0; i < times; i += 1) {
      t = start * (1 - i / (times - 1))
      computePositionStep(t, k)
    }

    for (i = 0; i < markerList.length; i++) {
      const disp = markerList[i].disp
      if (markerList[i].getTooltip()) {
        const tooltip_container = markerList[i].getTooltip()._container
        if (tooltip_container != null) {
          let p = getPosition(tooltip_container)
          const width = tooltip_container.offsetWidth - (markerList.length === 1 ? 170 : 0)
          const height = tooltip_container.offsetHeight - (markerList.length === 1 ? 170 : 0)
          p = L.point(Math.ceil(p.x - width / 2), Math.ceil(p.y - height / 2))
          L.DomUtil.setTransform(markerList[i].getTooltip()._container, p)
        }
      }
    }
  }

  function setEdgePosition () {
    const bounds = map.getBounds()
    const northWest = map.latLngToLayerPoint(bounds.getNorthWest())
    const southEast = map.latLngToLayerPoint(bounds.getSouthEast())

    for (let i = 0; i < markerList.length; i++) {
      if (markerList[i].getTooltip()) {
        const tooltip_container = markerList[i].getTooltip()._container
        const marker_icon = markerList[i]._icon
        if (tooltip_container != null && marker_icon != null) {
          const tooltip = getPosition(tooltip_container)
          const marker = getPosition(marker_icon)
          const width = tooltip_container.offsetWidth
          const height = tooltip_container.offsetHeight

          let isEdge = false
          if (marker.x > northWest.x && tooltip.x < northWest.x) {
            tooltip.x = northWest.x
            isEdge = true
          } else if (marker.x < southEast.x && tooltip.x > southEast.x - width) {
            tooltip.x = southEast.x - width
            isEdge = true
          }

          if (marker.y > northWest.y && tooltip.y < northWest.y) {
            tooltip.y = northWest.y
            isEdge = true
          } else if (marker.y < southEast.y && tooltip.y > southEast.y - height) {
            tooltip.y = southEast.y - height
            isEdge = true
          }

          if (!isEdge) {
            if (marker.x < northWest.x && tooltip.x > northWest.x - width) {
              tooltip.x = northWest.x - width
            } else if (marker.x > southEast.x && tooltip.x < southEast.x) {
              tooltip.x = southEast.x
            }

            if (marker.y < northWest.y && tooltip.y > northWest.y - height) {
              tooltip.y = northWest.y - height
            } else if (marker.y > southEast.y && tooltip.y < southEast.y) {
              tooltip.y = southEast.y
            }
          }

          L.DomUtil.setTransform(markerList[i].getTooltip()._container, tooltip)
        }
      }
    }
  }

  function showOnlyCurrentMarker (marker, leafletMap) {
    map = leafletMap
    markerList.forEach(function (item) {
      if (item !== marker) {
        map.removeLayer(item)
      }
    })
    removeAllPolyline(leafletMap)
  }

  TooltipLayout.initialize = initialize
  TooltipLayout.resetMarker = resetMarker
  TooltipLayout.getMarkers = getMarkers
  TooltipLayout.getLine = getLine
  TooltipLayout.removeAllPolyline = removeAllPolyline
  TooltipLayout.removeMarkers = removeMarkers
  TooltipLayout.showOnlyCurrentMarker = showOnlyCurrentMarker
  TooltipLayout.redraw = redraw

  return TooltipLayout
}, window)
